import type { HTMLAttributes, ReactNode } from 'react';
import { joinCss } from '@/shared/lib/css-utils';
import { Text } from '../text';
import css from './empty-state.module.scss';

type EmptyStateProps = HTMLAttributes<HTMLDivElement> & {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
};

export const EmptyState = ({
  icon,
  title,
  description,
  action,
  className,
  ...restProps
}: EmptyStateProps) => (
  <div className={joinCss(css.root, className)} {...restProps}>
    {icon && <div className={css.iconWrap}>{icon}</div>}
    <Text as="p" size="sm" weight="semibold">
      {title}
    </Text>
    {description && (
      <p className={css.descriptionWrap}>
        <Text as="span" variant="muted" size="sm">
          {description}
        </Text>
      </p>
    )}
    {action}
  </div>
);
